var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoc24Check = function SvgDoc24Check(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.793 13.293a1 1 0 0 1 1.414 0l1.293 1.293 3.293-3.293a1 1 0 0 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 0-1.414Z",
    fill: "#242424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 7a5 5 0 0 1 5-5h3.597a5 5 0 0 1 3.123 1.096l2.403 1.922A5 5 0 0 1 20 8.922V17a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V7Zm5-3a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V8.922A3 3 0 0 0 17.855 8H15a2 2 0 0 1-2-2V4.027A3.001 3.001 0 0 0 12.597 4H9Z",
    fill: "#242424"
  })));
};
export default SvgDoc24Check;